











































































import Vue from "vue";

export default Vue.extend({
    name: "MyPlanCard",
    props: {
        myPlanItem: {
            type: Object,
            required: true
        },
        orgConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        trainingOccupationEnabled(): boolean {
            if (Object.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        }
    }
});
